import React from "react";

import HeroSection from '../components/HeroSection';
import FeaturesSection from '../components/FeaturesSection';
import PricingSection from '../components/PricingSection';
import FAQSection from '../components/FAQSection';
import AppPreviewSection from '../components/AppPreviewSection';

const Home = () => {
  return (
    <>
      <HeroSection />
      <AppPreviewSection />
      <FeaturesSection />
      <PricingSection />
      <FAQSection />
    </>
  );
};

export default Home;